import React, { useState } from 'react';
import Navbar from '../Navbar.jsx';
import Footer from '../Foooter.jsx';
import FooterMovil from '../FooterMovil.jsx';
import UploadWidget from '../UploadWidget';
import '../../style/VerificationForm.css';
import api from "../../utils/apiClient";
import { useNavigate } from 'react-router-dom';

function VerificationForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombreCompleto: '',
    numeroIdentidad: '',
    telefono: '',
    direccion: '',
    documento: { url: '', name: '' }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUploadSuccess = (url) => {
    const name = url.split('/').pop();
    setFormData((prev) => ({ ...prev, documento: { url, name } }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('verification', formData);
      navigate('/');
    } catch (err) {
      console.error('Error sending verification:', err);
    }
  };

  return (
    <>
      <Navbar />
      <div className={"parent"}>
      <form className="verification-form" onSubmit={handleSubmit}>
      <h1>Formulario de verificacion</h1>
        <input
          type="text"
          name="nombreCompleto"
          placeholder="Nombre completo"
          value={formData.nombreCompleto}
          onChange={handleChange}
        />
        <input
          type="text"
          name="numeroIdentidad"
          placeholder="Número de identidad"
          value={formData.numeroIdentidad}
          onChange={handleChange}
        />
        <input
          type="text"
          name="telefono"
          placeholder="Número telefónico"
          value={formData.telefono}
          onChange={handleChange}
        />
        <input
          type="text"
          name="direccion"
          placeholder="Dirección"
          value={formData.direccion}
          onChange={handleChange}
        />
        <div>Ingrese una foto de su Tarjeta de identidad</div>
        <UploadWidget onUploadSuccess={handleUploadSuccess} />
        <input type="submit" className="red-button" value="Enviar" />
      </form>
      </div>
      <div className="footer">
        <Footer />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default VerificationForm;
